import axios from 'axios'
import { useCallback, useState } from 'react'

export interface RecommendedProduct {
    id: string
    name: string
    type: string
    description: string
    categories: string[]
    min_age: number
    max_age: number
    min_price: number
    location_name: string
    location_types: string[]
    company_name: string
    main_photo: any
    slug: string
    country_code: string
    country_name: string
    transport_type: string
    food_type: string
    tags: string[]
    nearest_trip: {
        id: string
        start_date: string
        end_date: string
        full_price: number
        available_spots: number
    } | null
    ai_match_score: number
    ai_match_reason: string
}

export interface BookingContext {
    booking_id: string
    user_name: string
    product_name: string
    kids: Array<{ first_name: string; age: number }>
    past_bookings_count: number
}

export interface AdminRecommendationsResponse {
    success: boolean
    recommendations: RecommendedProduct[]
    query_summary: string
    personalized: boolean
    total_candidates: number
    booking_context?: BookingContext
}

export const useAdminRecommendationsApi = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [data, setData] = useState<AdminRecommendationsResponse | null>(null)

    const searchByBooking = useCallback(
        async (
            bookingId: string,
            additionalContext?: string,
            maxResults = 6,
        ): Promise<AdminRecommendationsResponse | null> => {
            setLoading(true)
            setError(null)

            try {
                const url =
                    process.env.REACT_APP_WAKACJE_API_URL +
                    '/v1/recommendations/admin-search'

                const res = await axios.post(url, {
                    booking_id: bookingId,
                    additional_context: additionalContext || undefined,
                    maxResults,
                })

                const result: AdminRecommendationsResponse = res.data
                setData(result)
                setLoading(false)
                return result
            } catch (err: any) {
                const message =
                    err.response?.data?.message ??
                    'Wystąpił błąd podczas wyszukiwania rekomendacji'
                setError(message)
                setLoading(false)
                return null
            }
        },
        [],
    )

    const reset = useCallback(() => {
        setData(null)
        setError(null)
        setLoading(false)
    }, [])

    return { searchByBooking, loading, error, data, reset }
}
